import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsQueryKey, postOrgArtifactsMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const useCreateArtifact = () => {
  const $ = _c(6);
  const queryClient = useQueryClient();
  const showErrorToast = useRequestErrorToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = postOrgArtifactsMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = () => queryClient.invalidateQueries({
      queryKey: getOrgArtifactsQueryKey()
    });
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== showErrorToast || $[4] !== t1) {
    t2 = {
      ...t0,
      onSuccess: t1,
      onError: showErrorToast
    };
    $[3] = showErrorToast;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useMutation(t2);
};
export default useCreateArtifact;